import { classNameParser } from "../../../helpers";

function getButtonSizeClassName(size?: "large" | "small") {
  if (!size) return "button--default";
  if (size === "large") return "button--large";
  return "button--small";
}

function getButtonAppearanceClassName(appearance?: "primary" | "alt" | "secondary" | "tertiary" | "transparent") {
  switch (appearance) {
    case "primary":
      return "button--primary";
    case "alt":
      return "button--alt";
    case "tertiary":
      return "button--tertiary";
    case "transparent":
      return "button--transparent";
    case "secondary":
    default:
      return "button--secondary";
  }
}

export function getParsedButtonClassName(
  appearance?: "primary" | "alt" | "secondary" | "tertiary" | "transparent",
  className?: string,
  disabled?: boolean,
  size?: "large" | "small"
) {
  const appearanceClassName = getButtonAppearanceClassName(appearance);
  const sizeClassName = getButtonSizeClassName(size);
  const disabledClassName = disabled ? "button--disabled" : "";

  const defaultClassNames = `${sizeClassName} ${appearanceClassName} ${disabledClassName}`;

  return classNameParser(defaultClassNames, className);
}
